const getStorageValue = (key, valuePath, storageType = "session") => {
	const storage = storageType === "local" ? localStorage : sessionStorage;
	const storedItem = storage.getItem(key);
	if (!storedItem) return null;

	try {
		const parsedItem = JSON.parse(storedItem);
		const pathParts = valuePath.split(".");
		let currentValue = parsedItem;

		for (const part of pathParts) {
			if (currentValue && typeof currentValue === "object" && part in currentValue) {
				currentValue = currentValue[part];
			} else {
				return null;
			}
		}

		return currentValue;
	} catch (error) {
		console.error(`Error parsing JSON from ${storageType}Storage:`, error);
		return null;
	}
};

export default getStorageValue;